import { useParams } from "@tanstack/react-router";
import { useState } from "react";
import { rssCategoryRoute } from "app/router";
import { TableSearch } from "components/elements";
import { Spinner } from "components/elements/Spinner";
import { throttle } from "hooks/useThrottled";
import { trpc } from "lib/trpc";
import { RssFeedCard } from "./RssFeedCard";

export const FullCategory = () => {
    const [searchValue, setSearchValue] = useState("");
    const { categoryName: rawCategory } = useParams({ from: rssCategoryRoute.id });
    const decodedCategory = decodeURIComponent(rawCategory);

    const isLatest = decodedCategory.toLowerCase() === "latest";

    const latestQuery = trpc.rss.latestEntries.useQuery(
        { searchTerm: searchValue },
        { enabled: isLatest },
    );

    const groupedQuery = trpc.rss.entriesByFeed.useQuery(
        { feedId: Number(decodedCategory), searchTerm: searchValue },
        { enabled: !isLatest },
    );

    // incase we want to use categories in the future
    // const groupedQuery = trpc.rss.groupedEntries.useQuery(
    //     { category: decodedCategory },
    //     { enabled: !isLatest },
    // );

    const articles = isLatest
        ? (latestQuery.data?.entries ?? [])
        : (groupedQuery.data?.entries ?? []);

    const isLoading = isLatest ? latestQuery.isPending : groupedQuery.isPending;

    return (
        <div className="mx-auto w-full  items-center justify-center px-3 py-4">
            <div className="mb-3 flex w-full flex-row items-baseline justify-between">
                <h2 className="mb-6 text-2xl font-bold text-[#424242]">
                    {isLatest ? "Latest News" : articles[0]?.feedSourceTitle}
                </h2>
                <TableSearch value={searchValue} onChange={throttle(setSearchValue, 300)} />
            </div>
            <div className="flex flex-col justify-between">
                {isLoading ? (
                    <>
                        <div className="flex h-96 items-center justify-center">
                            <Spinner className="h-8 w-8" />
                        </div>
                    </>
                ) : (
                    <>
                        {articles.length === 0 ? (
                            <div className="flex h-96 items-center justify-center">
                                <p className="text-sm">No articles found.</p>
                            </div>
                        ) : (
                            <div className="columns-1 gap-4 space-y-4 sm:columns-2 lg:columns-4">
                                {articles.map((article) => (
                                    <div key={article.id} className="break-inside-avoid">
                                        <RssFeedCard
                                            articleId={article.id}
                                            title={article.title}
                                            description={article.excerpt}
                                            date={article.publishedAt?.split("T")[0] ?? ""}
                                            link={article.url ?? ""}
                                            imageUrl={article.imageUrl ?? ""}
                                            feedSourceTitle={article.feedSourceTitle}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
